import { useCallback, useMemo, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSidebarStore } from "../stores/sidebarStore";

export const useDropdownNavigation = (dropdownId, items = []) => {
  const location = useLocation();
  const { openDropdown, toggleDropdown, setOpenDropdown } = useSidebarStore();
  const hasInitialized = useRef(false);

  const isOpen = openDropdown === dropdownId;
  
  const hasActiveChild = useMemo(() => {
    return items.some(item => location.pathname === item.to);
  }, [items, location.pathname]);

  const isActive = hasActiveChild;

  const handleToggle = useCallback(() => {
    if (isOpen) {
      toggleDropdown(dropdownId);
    } else {
      setOpenDropdown(dropdownId);
    }
  }, [isOpen, toggleDropdown, setOpenDropdown, dropdownId]);

  useEffect(() => {
    if (hasActiveChild && !hasInitialized.current) {
      setOpenDropdown(dropdownId);
      hasInitialized.current = true;
    }
  }, [hasActiveChild, setOpenDropdown, dropdownId]);

  return {
    isOpen: isOpen || hasActiveChild,
    isActive,
    hasActiveChild,
    handleToggle,
  };
};
